<template>
  <div id="dv-full-screen-container1" :ref="ref">
    <template v-if="ready">
      <slot />
    </template>
  </div>
</template>

<script>
import autoResize from './autoResize'

export default {
  name: 'FullScreenContainer',
  mixins: [autoResize],
  data () {
    return {
      ref: 'full-screen-container',
      allWidth: 0,
      scale: 0,
      datavRoot: '',
      ready: false
    }
  },
  methods: {
    afterAutoResizeMixinInit () {
      const { initConfig, setAppScale } = this

      initConfig()

      setAppScale()

      this.ready = true
    },
    initConfig () {
      const { dom } = this
      const { width } = screen

      this.allWidth = width - 140
      dom.style.width = `${width - 130}px`
      // const height = document.getElementById('dv-full-screen-container').clientHeight
      // console.info(height)
    },
    setAppScale () {
      const { allWidth, dom } = this

      const currentWidth = document.getElementById('dv-full-screen-container1').parentNode.clientWidth - 50

      dom.style.transform = `scale(${currentWidth / (allWidth)})`
    },
    onResize () {
      const { setAppScale } = this

      setAppScale()
    }
  }
}
</script>

<style>
  #dv-full-screen-container1 {
    /*position: fixed;
    top: 0px;
    left: 0px;*/
    /*overflow-y: auto;*/
   /* overflow-x: hidden;
    overflow-y: auto;*/
    transform-origin: left top;
    z-index: 999;
  }

</style>
